import { IPageConfiguration } from '../../../domain/conf/page'
import { Entity } from '../../../domain/entity'
import { SimpleEvents } from '../../../utils/events'
import { IProfile } from '../../common/profile'
import { IProviderConfig } from '../../common/provider-config'

export enum SSOScreen {
    SIGN_IN = 'signIn',
    SIGN_OUT = 'signOut'
}

export interface IIdentityServiceAdapter<T extends IIdentityProviderConfig> extends SimpleEvents {
    enable(): void
    fetch(): IProfile
    hasSession(): Promise<boolean>
    initialize(creds: T, ...args: any[]): this
    registerInitHandler(): void
    signIn(): void
    signOut(): void
    closeModal?(): void
    removeCommentAdUI?(): void
}

export interface ISubscriberServiceAdapter extends IIdentityServiceAdapter<IIdentityProviderConfig> {
    getConversions(): Promise<string[]>
    getAccess(): Promise<ISubscription[]>
    registerForOneDigital(): Promise<void>
    pianoCloseModal(): void
}

export interface IIdentityProviderConfig extends IProviderConfig {
    application?: string
    page?: IPageConfiguration
    showPasswordPolicy?: boolean
}

export interface ISubscriberProviderConfig extends IIdentityProviderConfig {
    /**
     * Whitelist of subscription ids that determine if a user is a subscriber.
     */
    resIds?: string[]

    /**
     * For One Digital properties, the basic digital access term provided to all registrants.
     */
    registrantTermId?: string

    /**
     * The basic digital access term resource id
     */
    registrantResId?: string
}

export interface ISubscription {
    end?: number
    aid?: string
    id: string
    start: number
}

export class Subscription extends Entity implements ISubscription {
    public end?: number
    public aid?: string
    public id: string
    public start: number
}

export interface IIdentityLinksConfig {
    contact_us?: IIdentityLinkConfig,
    copyright?: IIdentityLinkConfig
    privacy_updated?: IIdentityLinkConfig
    site_map?: IIdentityLinkConfig
    terms?: IIdentityLinkConfig
}

export interface IIdentityLinkConfig {
    a_title?: string,
    link?: string
    title?: string
}
